import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: 'c2cc09de-7d7a-440b-ad6c-35527625b07e',
    countryCodes: ['NL'],
    locale: 'nl-NL',
});
